import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './OrbElement.scss';

const OrbElement = ({ id, position }) => {
  return <div key={`${position}-orb-${id}`} id={`orb-${id}`} data-testid={`orb-${id}`} className={classnames(position, 'orb-el')} />;
};

OrbElement.propTypes = {
  id: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['prev', 'curr', 'next']).isRequired,
};

export default OrbElement;
